import { PostProjectData } from '@round/api/dist/esm/types/src/creatorbase';
import { ApiResponseError } from '@round/api';
import * as yup from 'yup';
import { mapApiErrorsToFormikErrors } from 'utility/utility';
import { FormikErrors } from 'formik';
import { ProjectFormValues } from './ProjectForm';
import { MEGA_BYTE } from 'utility/constants';

export const projectFormValidationSchema = yup.object().shape({
    name: yup.string().required(),
    brand: yup.object().required('Artist is required').nullable(),
    image: yup
        .mixed()
        .nullable()
        .test('fileSize', 'File is too large. Max size: 5 MB', (value: File | null | undefined) => {
            return (value?.size ?? 0) <= 5 * MEGA_BYTE;
        }),
});

export const convertPostProjectFormApiErrorsToFormikErrors = (
    errorObject: ApiResponseError<PostProjectData>
): FormikErrors<ProjectFormValues> => {
    const errors = {
        ...errorObject,
        brand: errorObject.brand_id,
    };

    return mapApiErrorsToFormikErrors(errors);
};
